import { USER_ROLES } from '@src/packages/utils/access';

/** Where account holders reach us about trials and payments. */
export const ACCOUNT_CONTACT_EMAIL = 'contact@operonda.com';

/**
 * Roles that see trial and payment notices. Everyone else only learns about the account when
 * it can no longer be edited. Not an `ALLOWED_ROLES` write list on purpose: it must keep
 * working while the account is read-only.
 */
export const BILLING_NOTICE_ROLES = [USER_ROLES.OWNER, USER_ROLES.ORG_ADMIN];

export const DAY_MS = 24 * 60 * 60 * 1000;
